import { Component } from 'react';
// redux
import { connect } from 'react-redux';
import { logoutRequest } from '../../redux/reducers/auth';
// utils
import { clearAuthData } from '../../utils/authData';
import { toastResponseErrors } from '../../utils/response';

class Logout extends Component {
  componentWillMount() {
    const { logoutRequest, history } = this.props;
    logoutRequest()
      .then(() => {
        clearAuthData();
        history.push('/login');
      })
      .catch(toastResponseErrors);
  }

  render = () => null;
}

export default connect(
  null,
  { logoutRequest }
)(Logout);



// WEBPACK FOOTER //
// ./src/containers/Logout/Logout.js